import InputFields from '@components/common/InputFields';
import React, { useEffect, useMemo, useState } from 'react';
import VillagesDataModal from './VillagesDataModal';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const VillagesMapped =({labelName,formData,formState, isDisabled, allFormState, allFormData}:
    {labelName:string,formData:any,formState:any,isDisabled:any, allFormState:any, allFormData:any})=>{
    const [modal,setModal]=useState(false);
    const location =useLocation();
    const zoneId = location.pathname.split("edit/")[1];
    const districtByZone:any =useSelector((state:any)=>state.GeoNonGeoData.districtByZone);
    // let defaultValue:string= ' ';
    const getDefaultValue =useMemo(()=>{
        if(labelName.toLocaleLowerCase()==="district" && zoneId){
            return districtByZone[zoneId]?.map((d:any)=>d?.district_name).join(' , ');
        }
        return '';
    },[zoneId])

    const getSelectedItems =()=>{
        
        if(value && Array.isArray(value)){
            switch (labelName) {
                case "District":
                    return value?.map((item:any)=>item?.district_name).join(' , ');
                case "Villages Mapped":
                    return value?.map((item:any)=>item?.village_name).join(' , ')
                default:
                    return value?.map((item:any)=>item?.ward_name).join(' , ')
            }
        }
        return getDefaultValue;
        
    }
    const [optionsValue,setOptionsValue]=useState<boolean>(false);
    useEffect(()=>{
        if(labelName.toLocaleLowerCase()!=="district"){
            setValue('');
        }
    },[formData['#options']]);

    useEffect(()=>{
        if(allFormData.wards_mapped['#options']?.length > 0){
            allFormData.wards_mapped['#required'] = true;
        }
        else{
            allFormData.wards_mapped['#required'] = false;
        }
        if(allFormData.villages_mapped['#options']?.length > 0){
            allFormData.villages_mapped['#required'] = true;
        }
        else{
            allFormData.villages_mapped['#required'] = false;
        }
        if(allFormData.villages_mapped['#options']?.length===0 || allFormData.wards_mapped['#options']?.length === 0){
            setOptionsValue(true);
        }
    },[allFormData.wards_mapped['#options'], allFormData.villages_mapped['#options']])

    const [value,setValue]=useState(getDefaultValue);
    const onClickInput=()=>{
        setModal(true);
        if(formData['#options']?.length===0){
            setOptionsValue(true);
        }
        else{
            setOptionsValue(false);

        }
    }
    return <div>
        <InputFields
                placeholder={labelName}
                className={labelName}
                onChange={(changedData) => ''}
                labelName={labelName}
                isDisabled={isDisabled}
                type="text"
                required={!formData['#options']?.length?false:formData['#required']}
                value={getSelectedItems()}
                // value={labelName === 'Villages Mapped' ? formState?.value?.village_name : formState?.value?.ward_name}
                inputType={formState?.isError ?'error':'general'}
                errorMessage={formState?.isError ? formState?.message :''}
                onClick={onClickInput}
              />

                {modal && <VillagesDataModal setModal={setModal} setValue={setValue} formData={formData} formState={formState} labelName={labelName} value={value} allFormState={allFormState} allFormData={allFormData}/>
              }
    </div>;
}
export default VillagesMapped;